// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { Paper, Table, TableBody, TableCell, TableFooter, TableHead, TableRow, TextField } from '@mui/material'
import cx from 'classnames'
import React from 'react'
import { EditableConsumer } from '../../common/context/EditableContext'
import { i18n } from '../index'
import type { ManagementTarget, SalesIncentiveUnit, TargetFieldName, TargetType } from './dailyManagementTypes'
import css from './table.css'

const calculateTotal = (fieldName: TargetFieldName, targets: Array<ManagementTarget>): number => {
  const reducer = (sum, target) => sum + target[fieldName]

  return Math.round(targets.reduce(reducer, 0) * 100) / 100
}

type ShiftTargetRowProps = {
  data: ManagementTarget
  onChange: (...args: Array<any>) => any
}

const ShiftTargetRow = ({ data, onChange }: ShiftTargetRowProps) => (
  <EditableConsumer>
    {({ isEditable }) => (
      <TableRow className={css.tableRow}>
        <TableCell className={css.tableCell}>{i18n.t(`dailyManagement.label.shift${data.shift}`)}</TableCell>
        <TableCell
          className={cx(css.tableCell, css.tableCellCentered, {
            [css.tableCellEditable]: isEditable,
          })}
        >
          {isEditable ? (
            <TextField
              className={css.textField}
              placeholder='0'
              type='number'
              min={0}
              max={999}
              value={data.target || ''}
              onChange={onChange}
            />
          ) : (
            data.target || '0'
          )}
        </TableCell>
        <TableCell className={cx(css.tableCell, css.tableCellCentered)}>{data.actual || '0'}</TableCell>
      </TableRow>
    )}
  </EditableConsumer>
)

type ShiftTargetsProps = {
  type: TargetType
  unit: SalesIncentiveUnit
  data: Array<ManagementTarget>
  onChange: (...args: Array<any>) => any
}

const ShiftTargets = ({ type, unit, data, onChange }: ShiftTargetsProps) => (
  <Paper>
    <div className={css.component}>
      <Table className={css.table}>
        <TableHead>
          <TableRow className={css.tableHeadinRow}>
            <TableCell className={css.tableHeadingCell}>{i18n.t('dailyManagement.label.shiftName')}</TableCell>
            <TableCell className={cx(css.tableHeadingCell, css.tableCellCentered)}>
              {i18n.t('dailyManagement.label.target', {
                unit: unit === 'Euro' ? '€' : 'kpl',
              })}
            </TableCell>
            <TableCell className={cx(css.tableHeadingCell, css.tableCellCentered)}>
              {i18n.t('dailyManagement.label.actual', {
                unit: unit === 'Euro' ? '€' : 'kpl',
              })}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((data) => {
            const transformedData = Object.assign({}, data, {
              target: data.target ? Math.round(data.target * 100) / 100 : data.target,
              actual: data.actual ? Math.round(data.actual * 100) / 100 : data.actual,
            })
            return (
              <ShiftTargetRow
                data={transformedData}
                onChange={(e) => onChange(type, transformedData.shift, e.target.value)}
                key={transformedData.shift}
              />
            )
          })}
        </TableBody>
        <TableFooter>
          <TableRow className={css.tableFootRow}>
            <TableCell className={css.tableFootCell}>{i18n.t('dailyManagement.label.total')}</TableCell>
            <TableCell className={cx(css.tableFootCell, css.tableCellCentered)}>
              {calculateTotal('target', data)}
            </TableCell>
            <TableCell className={cx(css.tableFootCell, css.tableCellCentered)}>
              {calculateTotal('actual', data)}
            </TableCell>
          </TableRow>
        </TableFooter>
      </Table>
    </div>
  </Paper>
)

export default ShiftTargets
